module.exports = __webpack_public_path__ + "static/meda-provider1-e4e146ac8c30698b44d015cb51571db3.png";